export default __webpack_public_path__ + "static/media/backPink.0a08c649.svg";